import { Injectable, inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

@Injectable({
  providedIn: 'root',
})
export class MsalInitService {
  private msalService = inject(MsalService);

  private initPromise: Promise<void> | null = null;

  async ensureInitialized(): Promise<void> {
    // If already initialized, return immediately
    if ((this.msalService.instance as any)._initialized) {
      return;
    }

    // If initialization is in progress, return the existing promise
    if (this.initPromise) {
      return this.initPromise;
    }

    // Start initialization
    this.initPromise = this.msalService.instance.initialize().catch((error) => {
      // Reset promise on error so it can be retried
      this.initPromise = null;
      throw error;
    });

    return this.initPromise;
  }
}
